import React, { useEffect, useState } from 'react';
import './Products.css';
import ProductTemplate from './ProductTemplate';
import SearchProducts from './SearchProducts';
import { FormControlLabel, Checkbox, InputLabel, Select, MenuItem, FormControl, CircularProgress } from '@material-ui/core';
import cognizantImage from '../Images/cognizant-hs-120X45-21sep2018.gif';
import convanceImage from '../Images/convance-120x45-vk-27jan2021.gif';
import fisImage from '../Images/fis-p-120x45-30jan2018.gif';
import genpectImage from '../Images/genpact-vk-120x45-2feb2021.gif';
import hclImage from '../Images/hcl-ns-120x45-862020.gif';
import synechronImage from '../Images/synechron-ns-120x45-1512020.gif';
import spnnsor1 from '../Images/ezgif-6-4adc23fd8615.gif';
import spnnsor2 from '../Images/ezgif-6-43d7a52f5b28.gif';
import spnnsor3 from '../Images/ezgif-6-660f5e713de8.gif';
import NoCompanyLogo from '../Images/NoCompanyLogo.png';
import { useSelector, useDispatch } from 'react-redux';
import { selectFilterProductRecords, pushFilterProductRecords } from '../DataStore/Slices/productSlice';
import { useHistory, useParams } from 'react-router-dom';
import CustomPagination from './Pagination';
import { selectProductTitleOrKeywords } from '../DataStore/Slices/filterSlice';
import { filters } from './Models/ProductsModel';
import { getEmploymentTypeData, sleep } from './Models/CommonFunc';
import { Helmet } from 'react-helmet';
import { getAllEmployerDocument } from '../Backend/firebase/user';
import { getAllProductDocument, getProductDocumentWithUserId } from '../Backend/firebase/product';

export const sponsorsData = [
    {
        Id: 1,
        image: cognizantImage,
        sponsorName: 'Cognizant'
    },
    {
        Id: 2,
        image: convanceImage,
        sponsorName: 'Convance'
    },
    {
        Id: 3,
        image: fisImage,
        sponsorName: 'FIS'
    },
    {
        Id: 4,
        image: genpectImage,
        sponsorName: 'Genpect'
    },
    {
        Id: 5,
        image: hclImage,
        sponsorName: 'HCL'
    },
    {
        Id: 6,
        image: synechronImage,
        sponsorName: 'Synechron'
    },
    {
        Id: 7,
        image: spnnsor1,
        sponsorName: 'Spnnsor1'
    },
    {
        Id: 8,
        image: spnnsor2,
        sponsorName: 'Spnnsor2'
    },
    {
        Id: 9,
        image: spnnsor3,
        sponsorName: 'Spnnsor3'
    },
]

function Products() {
    const filterProductRecords = useSelector(selectFilterProductRecords);
    const dispatch = useDispatch();
    const history = useHistory();
    const [showPerPage, setShowPerPage] = useState(15);
    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage
    });
    const productTitleOrKeywordFilter = useSelector(selectProductTitleOrKeywords);
    const [sortDirectionDropDown, setSortDirectionDropDown] = useState('desc');
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const { isProductTitle } = useParams();

    const getAlert = (url) => {
        alert(url);
    };

    useEffect(async () => {
        console.log("filterProductRecords",filterProductRecords)
        if (!filterProductRecords) {
            await loadInitialProducts();
        }
        await sleep(5000);
        setIsFirstLoad(false);
    }, [filterProductRecords]);

    const loadInitialProducts = async () => {
        try {
            const getAllProducts = await getAllProductDocument();
            const getRetailer = await getAllEmployerDocument();
            let records = []
            getAllProducts?.map((productDoc) => {
                const userId = productDoc.userId;
                getRetailer?.map((retailerDoc) => {
                    if(retailerDoc.uid == userId) {
                        let objRecord = {}
                        Object.assign(objRecord, productDoc,  {storeName: retailerDoc.storeName, storeAddress: retailerDoc.storeAddress, storeCity: retailerDoc.storeCity})
                        records.push(objRecord)
                    }
                });
            });
            dispatch(pushFilterProductRecords({
                products: records
            }));
        } catch(error) {
            console.log("Error Occur in Get Products", error)
        }
    };

    const loadDataFromFilterSearch = async () => {
        filters.productTitleOrKeywords = productTitleOrKeywordFilter.ProductName === '' || productTitleOrKeywordFilter.ProductName === undefined ?
            '0' : productTitleOrKeywordFilter.ProductName;
        
        if (filters.productTitleOrKeywords != '0') {
            let items = filterProductRecords.products;
            let filterResult = items?.filter(x => x?.ProductName.toLowerCase().includes(filters?.productTitleOrKeywords.toLowerCase()) || 
                                x?.Compostions?.toLowerCase().includes(filters?.productTitleOrKeywords.toLowerCase()) ||
                                x?.storeName?.toLowerCase().includes(filters?.productTitleOrKeywords.toLowerCase()));
            
            if(filterResult.length > 0) {
                dispatch(pushFilterProductRecords({
                    products: filterResult
                }));
            } else {
                dispatch(pushFilterProductRecords({
                    products: []
                }));
            }
        }

    }

    useEffect(async () => {
        // history.push('/products');
        console.log("isProductTitle",isProductTitle)
        if (!isFirstLoad || isProductTitle) {
            console.log('productTitleOrKeywordFilter => ', productTitleOrKeywordFilter);
            await loadDataFromFilterSearch();
        }
    }, [productTitleOrKeywordFilter]);

    const onPaginationChange = (start, end) => {
        setPagination({
            start: start,
            end: end
        });
    };

    return (
        <>
            <div className="container-fluid">
                <Helmet>
                    <meta name="description" content="Search your dream product..." />
                    <title>Products | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="row">
                    <div className="col-lg-10 col-md-10 col-sm-12 mx-auto">
                        <div className="products">
                            <div className="products__banner mt-5">
                                <SearchProducts getAlert={getAlert} />
                            </div>
                            {filterProductRecords && filterProductRecords.products && filterProductRecords.products.length > 0 ? <div className="row products__banner products__contents">
                                <div className="col-md-12 col-sm-12 mt-2">
                                    <div className="products__sortDirection">
                                        <div className="products__productsCount">
                                            {(filterProductRecords && filterProductRecords.products.length > 0) && <span>{filterProductRecords.products.length} products found</span>}
                                        </div>
                                        <FormControl>
                                            <InputLabel id="demo-simple-select-label"></InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={sortDirectionDropDown}
                                                onChange={(e) => setSortDirectionDropDown(e.target.value)}>
                                                <MenuItem value='desc'>Newest Product First</MenuItem>
                                                <MenuItem value='asc'>Oldest Product First</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    {(filterProductRecords && filterProductRecords.products.length > 0 ) &&
                                        <div className="row">
                                            {
                                                filterProductRecords.products.slice(pagination.start, pagination.end).map((product) => {
                                                    return <ProductTemplate key={product.id} ProductId={product.uniqueId} Image={NoCompanyLogo} Compostions={product.Compostions}
                                                        ProductName={product.ProductName} MRP={product.MRP} PackagingSize={product.PackagingSize} Discount={product.Discount} PostedDate={product.ProductPostedDateTime}
                                                        RetailerUid={product.userId} StoreName={product.storeName} StoreAddress={product.storeAddress} />
                                                })
                                            }
                                        </div>
                                    }

                                    {
                                        filterProductRecords && filterProductRecords.products.length <= 0 ?
                                            <div className="text-center mt-3">
                                                <span style={{ fontWeight: '500', fontSize: '18px' }}>No Shops listed from Particluar City.</span>
                                            </div> :
                                            <div className="text-center mt-3">
                                                <div className="p-4">
                                                    {filterProductRecords && filterProductRecords.products.length > 0 ? '' : <CircularProgress />}
                                                </div>
                                            </div>
                                    }

                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                        <div>
                                            <FormControl style={{ width: '50px' }} size="small">
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={showPerPage}
                                                    onChange={(e) => setShowPerPage(e.target.value)}>
                                                    <MenuItem value={15}>15</MenuItem>
                                                    <MenuItem value={20}>20</MenuItem>
                                                    <MenuItem value={25}>25</MenuItem>
                                                    <MenuItem value={50}>50</MenuItem>
                                                </Select>
                                            </FormControl><span style={{ fontSize: '14px', marginLeft: '10px' }}>Show per page</span>
                                        </div>
                                        {filterProductRecords && <CustomPagination
                                            totalItem={Math.ceil(filterProductRecords.products.length / showPerPage)}
                                            onPaginationChange={onPaginationChange}
                                            showPerPage={showPerPage}
                                            records={filterProductRecords} />}
                                    </div>
                                </div>
                                <div className="col-md-2 mt-2"></div>
                            </div> : <div className="notFound">
                                {/* <CircularProgress /> */}
                                <div className="text-center mt-3">
                                    <span style={{ fontWeight: '500', fontSize: '18px' }}>No Shops listed from Particluar City.</span>
                                </div> 
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default Products
